import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapsible-section"
export default class extends Controller {
  static targets = ["content", "expandIcon"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")

    // Rotate the icon
    if (this.hasExpandIconTarget) {
      this.expandIconTarget.classList.toggle("rotate-180")
    }
  }
}
